<template>
  <div v-if="!loading">
    <form>
      <v-flex xs12>
        <v-autocomplete
          v-model="form.assigned_to_socialny_pracovnik"
          :disabled="form.closed"
          item-text="string_details"
          item-value="id"
          placeholder="Sociálny pracovník"
          label="Sociálny pracovník"
          :items="items_socialny_pracovnik"
          auto-select-first
          :search-input.sync="search_socialny_pracovnik"
          cache-items
          :loading="loading_socialny_pracovnik"
          hide-no-data
          :prepend-icon="socialnyPracovnikClosedIcon"
        />
        <v-autocomplete
          v-model="form.assigned_to_pedagog"
          :disabled="form.closed"
          item-text="string_details"
          item-value="id"
          placeholder="Pedagóg"
          label="Pedagóg"
          :items="items_pedagog"
          auto-select-first
          :search-input.sync="search_pedagog"
          cache-items
          :loading="loading_pedagog"
          hide-no-data
          :prepend-icon="pedagogClosedIcon"
        />
        <v-autocomplete
          v-model="form.assigned_to_psycholog"
          :disabled="form.closed"
          item-text="string_details"
          item-value="id"
          placeholder="Psychológ"
          label="Psychológ"
          :items="items_psycholog"
          auto-select-first
          :search-input.sync="search_psycholog"
          cache-items
          :loading="loading_psycholog"
          hide-no-data
          :prepend-icon="psychologClosedIcon"
        />
        <v-autocomplete
          v-model="form.assigned_to_pbs"
          :disabled="form.closed"
          item-text="string_details"
          item-value="id"
          placeholder="Príslušník PBS"
          label="Príslušník PBS"
          :items="items_pbs"
          auto-select-first
          :search-input.sync="search_pbs"
          cache-items
          :loading="loading_pbs"
          hide-no-data
          :prepend-icon="pbsClosedIcon"
        />
        <v-autocomplete
          v-if="form.type == 'RU'"
          v-model="form.assigned_to_socialny_kurator"
          :disabled="form.closed"
          item-text="string_details"
          item-value="id"
          placeholder="Sociálny kurátor"
          label="Sociálny kurátor"
          :items="items_socialny_kurator"
          auto-select-first
          :search-input.sync="search_socialny_kurator"
          cache-items
          :loading="loading_socialny_kurator"
          hide-no-data
          :prepend-icon="socialnyKuratorClosedIcon"
        />
        <v-autocomplete
          v-model="form.assigned_to_zastupca"
          :disabled="form.closed"
          item-text="string_details"
          item-value="id"
          placeholder="Zástupca"
          label="Zástupca"
          :items="items_zastupca"
          auto-select-first
          :search-input.sync="search_zastupca"
          cache-items
          :loading="loading_zastupca"
          hide-no-data
        />
      </v-flex>

      <div>
        <v-btn
          :disabled="form.closed"
          color="primary"
          @click="updateItem"
        >
          Uložiť
        </v-btn>
      </div>

      <v-divider class="my-10" />

      <div class="text-center">
        <v-btn
          class="ma-2"
          white--text
          color="secondary"
          @click="dialog_clone = true"
        >
          Klonovať formulár &nbsp;
          <v-icon>mdi-content-copy</v-icon>
        </v-btn>
        <v-btn
          v-if="form.closed"
          dark
          class="ma-2"
          white--text
          color="green"
          @click="dialog = true"
        >
          Otvoriť formulár &nbsp;
          <v-icon>mdi-lock-open</v-icon>
        </v-btn>
        <v-btn
          v-else
          :disabled="checkClosed"
          class="ma-2"
          white--text
          color="red"
          @click="closeItem"
        >
          Uzavrieť formulár &nbsp;
          <v-icon>mdi-lock-open</v-icon>
        </v-btn>
      </div>
    </form>

    <v-snackbar
      v-model="snackbar_saved"
      color="success"
      :timeout="3000"
    >
      Uložené
      <v-btn
        text
        @click="snackbar_saved = false"
      >
        Zavrieť
      </v-btn>
    </v-snackbar>
    <v-snackbar
      v-model="snackbar_error"
      color="error"
      :timeout="5000"
    >
      Chyba
    </v-snackbar>

    <v-dialog
      v-model="dialog"
      width="800px"
    >
      <v-card>
        <v-card-title>Otvorenie formulára</v-card-title>
        <v-container grid-list-sm>
          <v-layout wrap>
            <v-flex xs12>
              <v-text-field
                v-model="openReason.reason"
                label="Dôvod otvorenia formulára"
              />
            </v-flex>
          </v-layout>
        </v-container>
        <v-card-actions>
          <v-btn
            text
            color="primary"
            @click="dialog = false"
          >
            Zrušiť
          </v-btn>
          <v-btn
            text
            @click="openItem"
          >
            Otvoriť
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialog_clone"
      width="800px"
    >
      <v-card>
        <v-card-title>Klonovanie formulára</v-card-title>
        <v-container grid-list-sm>
          <v-layout wrap>
            <v-flex xs12>
              <v-autocomplete
                v-model="item_new.type"
                prepend-icon="mdi-ab-testing"
                placeholder="Typ kópie"
                label="Typ kópie"
                :items="types"
                required
              />
              <v-autocomplete
                v-model="item_new.comment"
                item-text="string_details"
                item-value="id"
                prepend-icon="mdi-comment"
                placeholder="Dôvod vytvorenia kópie"
                label="Dôvod vytvorenia kópie"
                :items="reasons"
                required
              />
            </v-flex>
          </v-layout>
        </v-container>
        <v-card-actions>
          <v-btn
            text
            color="primary"
            @click="dialog_clone = false"
          >
            Zrušiť
          </v-btn>
          <v-btn
            text
            @click="cloneItem"
          >
            Klonovať
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>

  <div v-else>
    <form-skeleton-component skeleton_type="simple" />
  </div>
</template>

<script>
import { APIService } from "@/http/APIService.js";
import FormSkeleton from "../../components/FormSkeleton.vue";

const apiService = new APIService();

export default {
  components: {
    "form-skeleton-component": FormSkeleton,
  },

  data: () => ({
    loading: false,
    timer: "",
    snackbar_saved: false,
    snackbar_error: false,
    dialog: false,
    dialog_clone: false,

    search_socialny_pracovnik: "",
    search_pedagog: "",
    search_psycholog: "",
    search_pbs: "",
    search_socialny_kurator: "",
    search_zastupca: "",

    loading_socialny_pracovnik: false,
    loading_pedagog: false,
    loading_psycholog: false,
    loading_pbs: false,
    loading_socialny_kurator: false,
    loading_zastupca: false,

    items_socialny_pracovnik: [],
    items_pedagog: [],
    items_psycholog: [],
    items_pbs: [],
    items_socialny_kurator: [],
    items_zastupca: [],

    item_new: {
      type: "",
      comment: "",
    },
    form: {
      nahodne_overenie_full: {
        closed: false,
      },
      poznatky_pbs_full: {
        closed: false,
      },
      penitenciarne_zaobchadzanie_full: {
        closed: false,
      },
      psychologicke_vysetrenie_full: {
        closed: false,
      },
      rizikove_faktory_full: {
        closed: false,
      },
      socialny_kurator_full: {
        closed: false,
      },
    },
    openReason: {
      cr_cra: "",
      user: "",
      reason: "",
    },
    types: ["CR", "RU"],
    reasons: [
      "Hodnotenie odsúdeného na podmienečné prepustenie",
      "Hodnotenie odsúdeného pred skončením výkonu trestu",
      "Hodnotenie odsúdeného pred umiestnením do VODD",
    ],
  }),

  computed: {
    socialnyPracovnikClosedIcon() {
      if (this.form.rizikove_faktory_full.closed) return "mdi-check";
      else return "mdi-close";
    },
    pedagogClosedIcon() {
      if (this.form.penitenciarne_zaobchadzanie_full.closed) return "mdi-check";
      else return "mdi-close";
    },
    psychologClosedIcon() {
      if (this.form.psychologicke_vysetrenie_full.closed) return "mdi-check";
      else return "mdi-close";
    },
    pbsClosedIcon() {
      if (this.form.poznatky_pbs_full.closed) return "mdi-check";
      else return "mdi-close";
    },
    socialnyKuratorClosedIcon() {
      if (this.form.socialny_kurator_full.closed) return "mdi-check";
      else return "mdi-close";
    },
    checkClosed() {
      if (this.form.version == 1) {
        if (this.form.type == "RU") {
          if (
            this.form.nahodne_overenie_full.closed &&
            this.form.poznatky_pbs_full.closed &&
            this.form.penitenciarne_zaobchadzanie_full.closed &&
            this.form.psychologicke_vysetrenie_full.closed &&
            this.form.rizikove_faktory_full.closed &&
            this.form.socialny_kurator_full.closed
          )
            return false;
        }
        if (this.form.type == "CR") {
          if (
            this.form.nahodne_overenie_full.closed &&
            this.form.poznatky_pbs_full.closed &&
            this.form.penitenciarne_zaobchadzanie_full.closed &&
            this.form.psychologicke_vysetrenie_full.closed &&
            this.form.rizikove_faktory_full.closed
          )
            return false;
        }
      } else if (this.form.version == 2) {
        if (this.form.type == "RU") {
          if (
            this.form.poznatky_pbs_full.closed &&
            this.form.penitenciarne_zaobchadzanie_full.closed &&
            this.form.psychologicke_vysetrenie_full.closed &&
            this.form.rizikove_faktory_full.closed &&
            this.form.socialny_kurator_full.closed
          )
            return false;
        }
        if (this.form.type == "CR") {
          if (
            this.form.poznatky_pbs_full.closed &&
            this.form.penitenciarne_zaobchadzanie_full.closed &&
            this.form.psychologicke_vysetrenie_full.closed &&
            this.form.rizikove_faktory_full.closed
          )
            return false;
        }
      }

      return true;
    },
  },

  watch: {
    search_socialny_pracovnik(val) {
      val && this.querySelectionsSocialnyPracovnik(val);
    },
    search_pedagog(val) {
      val && this.querySelectionsPedagog(val);
    },
    search_psycholog(val) {
      val && this.querySelectionsPsycholog(val);
    },
    search_pbs(val) {
      val && this.querySelectionsPBS(val);
    },
    search_socialny_kurator(val) {
      val && this.querySelectionsSocialnyKurator(val);
    },
    search_zastupca(val) {
      val && this.querySelectionsZastupca(val);
    },
  },

  mounted() {
    this.getItems();

    this.timer = setInterval(this.getFormsStatus, 30000);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },

  methods: {
    getFormsStatus() {
      apiService.getCraForm(this.$route.params.id).then((response) => {
        this.form.rizikove_faktory_full = response.rizikove_faktory_full;
        this.form.penitenciarne_zaobchadzanie_full = response.penitenciarne_zaobchadzanie_full;
        this.form.psychologicke_vysetrenie_full = response.psychologicke_vysetrenie_full;
        this.form.poznatky_pbs_full = response.poznatky_pbs_full;
        this.form.socialny_kurator_full = response.socialny_kurator_full;
      });
    },

    cloneItem() {
      apiService.cloneCraForm(this.$route.params.id, this.item_new).then(
        () => {
          this.dialog_clone = false;
          this.snackbar_saved = true;

        },
      );
    },
    getItems() {
      this.loading = true;
      apiService.getCraForm(this.$route.params.id).then((response) => {
        this.form = response;
        if (this.form.assigned_to_socialny_pracovnik_full != null) {
          this.items_socialny_pracovnik.push(
            this.form.assigned_to_socialny_pracovnik_full
          );
        }

        if (this.form.assigned_to_pedagog_full != null) {
          this.items_pedagog.push(this.form.assigned_to_pedagog_full);
        }

        if (this.form.assigned_to_psycholog_full != null) {
          this.items_psycholog.push(this.form.assigned_to_psycholog_full);
        }

        if (this.form.assigned_to_pbs_full != null) {
          this.items_pbs.push(this.form.assigned_to_pbs_full);
        }

        if (this.form.assigned_to_socialny_kurator_full != null) {
          this.items_socialny_kurator.push(
            this.form.assigned_to_socialny_kurator_full
          );
        }

        if (this.form.assigned_to_zastupca_full != null) {
          this.items_zastupca.push(this.form.assigned_to_zastupca_full);
        }
        this.loading = false;
      });
    },
    updateItem() {
      apiService.updateCraForm(this.form).then(
        (response) => {
          this.form = response;
          this.snackbar_saved = true;
          this.$root.$emit('ecra_part_updated');
        },
        () => {
          this.snackbar_error = true;
        }
      );
    },
    closeItem() {
      this.form.closed = true;
      this.updateItem();
    },
    openItem() {
      this.openReason.cr_cra = this.form.id;
      apiService.createOpenReason(this.openReason, this.form.id).then(
        () => {
          this.openReason.reason = "";
          this.form.closed = false;
          this.snackbar_saved = true;

          this.updateItem();

          this.dialog = false;
        },
        () => {
          this.snackbar_error = true;
        }
      );
    },
    querySelectionsSocialnyPracovnik(v) {
      this.loading_socialny_pracovnik = true;

      apiService.searchUsers(v).then((response) => {
        this.items_socialny_pracovnik = response.results;
        this.loading_socialny_pracovnik = false;
      });
    },

    querySelectionsPedagog(v) {
      this.loading_pedagog = true;

      apiService.searchUsers(v).then((response) => {
        this.items_pedagog = response.results;
        this.loading_pedagog = false;
      });
    },
    querySelectionsPsycholog(v) {
      this.loading_psycholog = true;

      apiService.searchUsers(v).then((response) => {
        this.items_psycholog = response.results;
        this.loading_psycholog = false;
      });
    },
    querySelectionsPBS(v) {
      this.loading_pbs = true;

      apiService.searchUsers(v).then((response) => {
        this.items_pbs = response.results;
        this.loading_pbs = false;
      });
    },
    querySelectionsSocialnyKurator(v) {
      this.loading_socialny_kurator = true;

      apiService.searchUsers(v).then((response) => {
        this.items_socialny_kurator = response.results;
        this.loading_socialny_kurator = false;
      });
    },
    querySelectionsZastupca(v) {
      this.loading_zastupca = true;

      apiService.searchUsers(v).then((response) => {
        this.items_zastupca = response.results;
        this.loading_zastupca = false;
      });
    },
  },
};
</script>
